import { render } from "./CheckboxList.vue?vue&type=template&id=70261e18"
import script from "./CheckboxList.vue?vue&type=script&lang=js"
export * from "./CheckboxList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/CheckboxList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70261e18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70261e18', __exports__)) {
    api.reload('70261e18', __exports__)
  }
  
  module.hot.accept("./CheckboxList.vue?vue&type=template&id=70261e18", () => {
    api.rerender('70261e18', render)
  })

}


export default __exports__